import { useState } from 'react';
import { Akun } from "../../model/Akun";
import { Eye, Edit3, EyeOff, Trash2 } from 'lucide-react';

export let akuns : Akun[] = [
]

const updateAkunsData = (updatedData = []) => {
  akuns.length = 0; // Clear the existing array
  updatedData.forEach((item: any) => {
    akuns.push({
      id            : item.id || 'undefined',
      email_address : item.email_address || 'Tidak ada Email Address',
      username      : item.username || 'Tidak ada Username',
      password      : item.password || 'Tidak ada Password',
      role          : item.role || 'Tidak ada informasi status',
      no_telp       : item.no_telp || 'Tidak ada informasi Nomor Telepon'
    });
  });
}  

export const fetchGetAkunAll = async () => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", key);

  const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/account")
  return await fetch(apiUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => { updateAkunsData(result.data ?? []); return { "status" : result.status, "message" : result.message, data: akuns }; })
      .catch((error : any) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message , data: []} });
}

export const fetchPostAkun = async ({ akun } : { akun : any}) => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Authorization", key);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(akun),
    redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/account");
  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => { return { "status" : result.status, "message" : result.message }; })
    .catch((error) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message } });
}

export const fetchPutAkun = async ({ id , akun } : { id : string; akun : any}) => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Authorization", key);

  const requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: JSON.stringify(akun),
    redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/account/" + id);
  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => { return { "status" : result.status, "message" : result.message }; })
    .catch((error) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message } });
}

export const fetchDeleteAkun = async (id : string) => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Authorization", key);

  const requestOptions: RequestInit = {
    method: "DELETE",
    headers: myHeaders,
    redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/account/" + id);
  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => { return { "status" : result.status, "message" : result.message }; })
    .catch((error) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message } });
}

export const RenderTableAkun = ({ data, onOpenDetail, onOpenEdit, onRemoveState }: { 
    data: Akun[] | null; 
    onOpenDetail : (employee: Akun) => void;
    onOpenEdit : (employee: Akun) => void;
    onRemoveState : () => void;
  }) => {
    
    const PasswordCell = ({ password }: { password: string }) => {
        const [show, setShow] = useState(false);
      
        return (
          <td className=" whitespace-nowrap text-sm text-gray-900 flex items-center gap-2">
            <span>{show ? password : "•".repeat(password.length)}</span>
            <button
              type="button"
              onClick={() => setShow((prev) => !prev)}
              className="text-gray-500 hover:text-gray-700"
            >
              {show ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </td>
        );
    }

    return(
      <>
        {
          data && data.length > 0 ? (
            data.map((akun) => (
                <tr key={akun.id} className="hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {akun.email_address}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {akun.username}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  <span>
                    <PasswordCell password={akun.password} />
                  </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  <span>
                    {akun.no_telp}
                  </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {akun.role}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <div className="flex space-x-2">
                        <button onClick={() => { onOpenEdit(akun) }} className="text-green-600 hover:text-green-900 p-1 rounded">
                            <Edit3 className="w-4 h-4" />
                        </button>
                        <button 
                            onClick={ async () => { try{ if(window.confirm(`Yakin hapus ${akun.username}?`)) { await fetchDeleteAkun(akun?.id); } onRemoveState() } catch (err) { console.error("Gagal hapus:", err); } } } 
                            className="text-red-600 hover:text-red-900 p-1 rounded">
                            <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                  </td>
                </tr>
            ))
          ) : (
            <tr>
              <td colSpan={6} className="text-center py-4 text-gray-500">
                Tidak ada data
              </td>
            </tr>
          )
        }
      </>
    );
}

export const FormAkunModal = ({ akunDetail, statusForm, setShowFormModal, onPostState } : {
    akunDetail        : Akun | null,
    statusForm        : string,
    setShowFormModal  : (show: boolean) => void | false; 
    onPostState       : () => void 
  }) => {
  
  const [formData, setFormData] = useState<Akun | null>(() => {
    if (statusForm === "add") {
      return {
        id            : "",
        email_address : "",
        username      : "",
        password      : "",
        role          : "user",
        no_telp       : "",
      };
    }
    return akunDetail;
  });

  
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [showPassword, setShowPassword] = useState(false);


  if (!formData) return null; // safety
  // fungsi validasi
  const validate = () => {
    const newErrors: { [key: string]: string } = {};

    if (!formData.email_address.trim()) newErrors.email_address = "Email Address wajib diisi";
    if (!formData.username.trim()) newErrors.username = "Username wajib diisi";
    if (!formData.password) newErrors.password = "Password wajib diisi";
    if (!formData.no_telp) newErrors.password = "No Telp wajib diisi";
    if (!formData.role) newErrors.status = "Pilih status Akun";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // true kalau tidak ada error
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    if(statusForm === 'add') await fetchPostAkun({ akun: formData });
    else await fetchPutAkun({ id: formData.id, akun: formData})
    setShowFormModal(false);
    onPostState();
  };

  

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-xl font-semibold text-gray-800">{statusForm === "add" ? 'Tambah Akun Baru' : `Edit ${formData.username}`}</h3>
            <button onClick={() => setShowFormModal(false)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors">✕</button>
          </div>
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email Address
              </label>
              <input
                type="text"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Masukkan Email Address"
                value={formData.email_address ?? ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    email_address: e.target.value,
                  })
                }
              />
              {errors.email_address && (
                <p className="text-sm text-red-500 mt-1">{errors.email_address}</p>
              )}
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Username
              </label>
              <input
                type="text"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Masukkan Username"
                value={formData.username ?? ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    username: e.target.value,
                  })
                }
              />
              {errors.username && (
                <p className="text-sm text-red-500 mt-1">{errors.username}</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Masukkan Password"
                  value={formData.password ?? ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      password: e.target.value,
                    })
                  }
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700"
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
              {errors.password && (
                <p className="text-sm text-red-500 mt-1">{errors.password}</p>
              )}
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                No. Telepon
              </label>
              <input
                type="text"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Masukkan No Telepon"
                value={formData.no_telp ?? ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    no_telp: e.target.value,
                  })
                }
              />
              {errors.no_telp && (
                <p className="text-sm text-red-500 mt-1">{errors.no_telp}</p>
              )}
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Status Akun
              </label>
              <select 
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                value={formData?.role || "-"}
                onChange={(e) => setFormData({ ...formData, role: e.target.value })}
              >
                <option value="-" disabled>Pilih Status</option>
                <option value="admin">Admin</option>
                <option value="pegawai">Pegawai</option>
                <option value="user">User</option>
              </select>
              {errors.status && (
                <p className="text-sm text-red-500 mt-1">{errors.status}</p>
              )}
            </div>
                        
            <div className="flex space-x-3 pt-4">
              <button
                onClick={() => setShowFormModal(false)}
                className="flex-1 px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
              >
                Batal
              </button>
              <button
                onClick={handleSubmit}
                className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Simpan
              </button>
            </div>
          </div>
    
        </div>
    </div>
  )
};
